<template>
  <Popup :ref="(el) => popup = el"
         class="popup--two-factor"
         :title="$t('labels.2fa_required')"
         @onClose="cancel2faCode"
  >
    <form class="two-factor-form">
      <div class="popup__content">
        <FormInputWrapper v-slot="parentProps" :errors="helper.getErrors('2fa', 'X-2FA-CODE')" >
          <input ref="twoFaInput" type="text"
                 @keydown.enter="() => confirm2faCode()"
                 v-maska
                 data-maska="999 999"
                 data-maska-tokens="9:[0-9]"
                 :class="parentProps.class" class="form-control tfa-code" v-model="twoFaCode" :placeholder="$t('labels.2fa_enter_code')">
        </FormInputWrapper>
      </div>
      <div class="popup__controls">
        <button type="button" @click="cancel2faCode" class="btn popup__close">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="confirm2faCode" class="btn btn--accept" type="submit">
          <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.2044 1.6485L4.74285 9.34081C4.67197 9.42524 4.58377 9.49344 4.48423 9.5408C4.3847 9.58817 4.27614 9.61358 4.16592 9.61533H4.15294C4.04512 9.61529 3.93852 9.59259 3.84004 9.54869C3.74156 9.5048 3.65341 9.44069 3.58131 9.36052L0.812078 6.2836C0.741749 6.20901 0.68704 6.12111 0.651168 6.02507C0.615295 5.92903 0.598982 5.82679 0.603186 5.72436C0.607391 5.62193 0.632028 5.52137 0.675651 5.42859C0.719274 5.33581 0.781003 5.2527 0.857208 5.18412C0.933414 5.11554 1.02256 5.06289 1.1194 5.02925C1.21625 4.99562 1.31884 4.98168 1.42115 4.98826C1.52346 4.99484 1.62342 5.02181 1.71515 5.06757C1.80689 5.11334 1.88856 5.17698 1.95535 5.25475L4.13275 7.67399L10.0265 0.659081C10.1587 0.506234 10.3457 0.411551 10.5472 0.395499C10.7486 0.379446 10.9483 0.443313 11.1031 0.573295C11.2578 0.703277 11.3552 0.888932 11.3741 1.09013C11.3931 1.29133 11.3321 1.4919 11.2044 1.6485Z" fill="#F7F9FC" />
          </svg>
          {{ $t('labels.2fa_verify') }}
        </LoaderButton>
      </div>
    </form>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import axios from "axios";
import {$t, helper} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";

export default defineComponent({
  methods: {$t},
  components: {LoaderButton, FormInputWrapper, Popup},
  setup(props) {
    const twoFaInput = ref<InstanceType<typeof HTMLElement> | null>(null)
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const state = reactive({
      visible: false,
      config: null as any,
      resolve2fa: null as any,
      reject2fa: null as any,
      twoFaCode: ""
    });

    const cancel2faCode = async () => {
      state.reject2fa && state.reject2fa()
      state.config = null
      hide()
    }

    const confirm2faCode = async () => {
      try {
        state.config.headers['x-2fa-code'] = state.twoFaCode.replace(" ", "")
        const resp = await axios.request(state.config);
        state.resolve2fa(resp)
        state.config = null
        hide()
      } catch (e) {
        helper.handleErrors('2fa', e)
        const errors = helper.getErrors('2fa', 'X-2FA-CODE');
        if (!errors || errors.length === 0) {
          state.reject2fa(e)
          state.config = null
          hide()
        }
      }
    }

    const show = (config: any, resolve: any, reject: any) => {
      popup.value?.show()
      state.config = config
      state.resolve2fa = resolve
      state.reject2fa = reject
      state.twoFaCode = ''
      helper.clearErrors('2fa')
      const interval = setInterval(() => {
        twoFaInput.value?.focus()
        if (twoFaInput.value) {
          clearInterval(interval)
        }
      }, 100)
    }

    const hide = () => {
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      cancel2faCode,
      confirm2faCode,
      twoFaInput,
      popup,
      helper,
      show,
      hide,
    }
  }
})
</script>
